import styled from 'styled-components';

const ChevronLarge = styled.i`
  font-size: 18px;
  vertical-align: middle;
`;

export default ChevronLarge;
